import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { filter, Observable, switchMap, take, tap, timer } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SbkLoansDataService {
    private apiRoot = '/api';
    private servicePath = '/omni-integration-service';

    constructor(private readonly http: HttpClient) { }

    // Available loans
    getAvailableLoans(loanType = ""): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans?callType=getLoans`;

        return this.http.get(uri);
    }

    // Active loans
    getActiveLoans(): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans`;

        return this.http.get(uri);
    }

    // Apply loan
    applyLoan(payload: any): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans/apply`;

        return this.http.post(uri, payload);
    }

    applyCarLoan(payload: any): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}/bb-email-integration/create-loan-lead`;

        return this.http.post(uri, payload);
    }

    applyHomeLoan(payload: any): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}/bb-email-integration/create-loan-lead`;

        return this.http.post(uri, payload);
    }

    applyCreditCardLoan(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-email-integration/create-loan-lead`;

        return this.http.post(uri, payload);
    }

    getHomeLoanPurposes(): Observable<any> {
        const uri = `${this.apiRoot}/contentservices/client-api/contentstream/portalRepository/custom/home-loan-purpose`;
        return this.http.get(uri);
    }

    getCarLoanPurposes(): Observable<any> {
        const uri = `${this.apiRoot}/contentservices/client-api/contentstream/portalRepository/custom/car-loan-purpose`;
        return this.http.get(uri);
    }

    getCreditCardTypes(): Observable<any> {
        const uri = `${this.apiRoot}/contentservices/client-api/contentstream/portalRepository/custom/credit-card-types`;
        return this.http.get(uri);
    }

    // Loan application confirmation
    confirmLoanApplicationStatus(payload: any, confirmationId: string): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans/apply`;

        const headers = new HttpHeaders({
            'X-CONFIRMATION-ID': confirmationId,
        });

        return this.http.post(uri, payload, { headers });
    }

    // Top up loan
    topUpLoan(payload: any): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans/topup`;

        return this.http.post(uri, payload);
    }

    // Top up loan confirmation
    confirmLoanTopUpStatus(payload: any, confirmationId: string): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans/topup`;

        const headers = new HttpHeaders({
            'X-CONFIRMATION-ID': confirmationId,
        });

        return this.http.post(uri, payload, { headers });
    }

    // Repay loan
    repayLoan(payload: any): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans/repay`;

        return this.http.post(uri, payload);
    }

    // Loan repayment confirmation
    confirmLoanRepaymentStatus(payload: any, confirmationId: string): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans/repay`;

        const headers = new HttpHeaders({
            'X-CONFIRMATION-ID': confirmationId,
        });

        return this.http.post(uri, payload, { headers });
    }
}
